module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp1_0.f01a2ced.png";